// extracted by mini-css-extract-plugin
export default {"card":"QueueEpisodeCard_card__bKpZU","icon":"QueueEpisodeCard_icon__gB9YY"};